import { Component, OnInit } from '@angular/core';
import {DialogModel} from "@shared/models/dialog.model";
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import {PlatformCommand} from "@shared/commands/command-base";
import {Api} from "@shared/constants/common-field.constants";

@Component({
    standalone: false,
    selector: 'particle-cbc-local-file-required-dialog-editor',
  templateUrl: './cbc-local-file-required-dialog-editor.component.html',
  styleUrls: ['./cbc-local-file-required-dialog-editor.component.scss']
})
export class CbcLocalFileRequiredDialogEditorComponent implements OnInit, IDialogView {

  data: DialogModel;
  item: any;
  fieldDefinition: any;

  cbcLocalFileRequiredDefaultValue: any;
  LocalFileRequiredOverwrite: any = false;
  overwrittenCellValue: any;

  constructor() { }

  ngOnInit(): void {
    this.item = this.data.input['item'];
    this.fieldDefinition = this.data.input['fieldDefinition'];
    this.cbcLocalFileRequiredDefaultValue = this.item.cells['CbCLocalFileRequiredDefaultValue'].displayText;
    const LocalFileRequiredOverwriteValue = this.item.cells['IsCbCLocalFileRequiredOverwritten'].displayText;
    this.overwrittenCellValue = this.item.cells['JT37'].displayText;
    if(LocalFileRequiredOverwriteValue === 'Yes'){
      this.LocalFileRequiredOverwrite = true;
    }
  }

  onOkClicked(): any {
    this.data.input.NextExecutionCommand = this.getNextExecutionCommand();
    this.data.input.HasUpdate = this.HasUpdate();
    return true;
  }

  getNextExecutionCommand(){
    const command = new PlatformCommand('UpdateCbCComplianceCommand', Api.DueDateTracker);
    command.setValue('LocalFileRequiredCell', true);
    command.setValue('ItemId', this.item.id);
    command.setValue('IsLocalFileRequired', this.overwrittenCellValue === 'Yes');
    command.setValue('LocalFileRequiredOverwritten', this.LocalFileRequiredOverwrite);
    command.setValue('StrategyType', 'UpdateLocalFileRequiredStrategy');
    command.projectId = '[PROJECT_ID]';
    return command;
  }

  private HasUpdate(): boolean {
    if(this.overwrittenCellValue !== this.item.cells['JT37'].displayText) return true;
    else if(this.LocalFileRequiredOverwrite !== this.ConvertBoolean(this.item.cells['IsCbCLocalFileRequiredOverwritten'].displayText)){
      return true;
    }
    return false;
  }

  private ConvertBoolean = (value: any): boolean => value === 'Yes';

}
